module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-range-922d69f0.svg";